import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateErfinaProductRequestDto,
  CreateErfinaProductResponseDto
} from "../../dtos/erfina-product-dto";
import { ProductService } from "../../services/product-service";

type UsePutUpdateErfinaProductMutationParams = {
  options?: UseMutationOptions<
    CreateErfinaProductResponseDto,
    unknown,
    CreateErfinaProductRequestDto & { productId: string }
  >;
};

export const usePutUpdateErfinaProductMutation = ({
  options
}: UsePutUpdateErfinaProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.updateErfinaProduct({ payload });
    },
    ...options
  });
};
